import React, { useEffect, useState } from "react";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { CalendarDateRangeIcon } from "@heroicons/react/20/solid";
import uuid from "react-uuid";
import Swal from "sweetalert2";
import {
  AXIOS_GET,
  AXIOS_GET_CAL_SCHEDULED_EVENTS,
  AXIOS_POST,
  AXIOS_UPDATE,
} from "../server/api/crud";
import Spinner from "./Spinner";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getAdmins, getAfspraken, getUserdetails, setAfspraken } from "../Localstorage/localstorage";
import { setAppointment, setAppointmentsCalendly, setAppointmentsCalendlyDelete, setAppointmentsCalendlyLoad } from "../redux/appointmentSlice";
import { sendEmail } from "../function";
import { emailHTML } from "../EmailTemplates";

const Calendly = ({ open, setOpen }) => {
  const [data, setData] = useState([]);
  const [allUsers, setallUsers] = useState([]);
  const [allUsersDet, setallUsersDet] = useState([]);
  const userdetails =  getUserdetails();

  const [bulk, setBulk] = useState({ users: [] });
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const admins = getAdmins();
  const { patienten } = useSelector((state) => state.user);

  const { appointmentsCalendly } = useSelector((state) => state.appointment);

  const deleteAfspraak = (index) => {
    const afspraken = appointmentsCalendly?.filter((item,key) => index !== key );
    dispatch(setAppointmentsCalendlyLoad(afspraken));
    setAfspraken(afspraken);
    setData(afspraken);

    //console.log(afspraken)
  }

  useEffect(() => {
    async function fetchData() {
      if (!open) return;
      setLoading(true);
      try {
        const respUser = await AXIOS_GET("users/all/patienten/not");
        let datass = (respUser?.data?.data || []).filter(
          (user) =>
            user?.username != "test2" &&
            user?.username != "test3" &&
            user?.role_id == 2
        );

        const usernames = datass
          ?.map((obj) => obj.username)
          .filter((username) => username != "test2" && username != "test3");

        const cachedAfspraken = getAfspraken() || [];
        if (appointmentsCalendly?.length > 0) {
          setData(appointmentsCalendly);
        } else {
          setData(cachedAfspraken);
        }
        setallUsers(usernames || []);
      } catch (error) {
        console.error("Error loading Calendly modal data:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [open, appointmentsCalendly]);

  const handleSignUp = async (invitee, event,index = 0) => {
    const { name, email, phone, first_name, last_name } = invitee;
    const { start_time, end_time, created_at, creators } = event;
    const type = event?.name;
    const { user_email, user_name } = creators[0];
    const username = email;
    const password = `${username}_${uuid().split("-")[0]}`;

    //console.log(event);

    //check als gebruiker bestaat;
    const Finduser = patienten.find((user) => user.email == email);

    //check als Admin bestaat;
    const FindAdmin = admins.find((user) => user.email == user_email);

    // Validate user input
    if (!validateUserInput(username, password)) return;

    // Get confirmation
    const result = await Swal.fire({
      title: `Wenst u deze ${username} in te schrijven`,
      showCancelButton: true,
      confirmButtonText: "Ja",
      cancelButtonColor: "gray",
      cancelButtonText: "Annuleer",
      confirmButtonColor: "darkgreen",
    });

    if (!result.isConfirmed) return;

    try {
      const id = uuid();

      // Create user
      await createUser(id, username, password);

      // Update user details
      const userDetails = {
        first_name: name?.split(" ")[0] || first_name,
        last_name: name?.split(" ")[1] || last_name,
        full_name: name || `${first_name} ${last_name}`,
        email,
        phone_number: phone,
        more_details: invitee?.questions_and_answers[0]?.answer,
      };
      await updateUserDetails(id, userDetails);

      const emailData = {
        from_name: "RepeatHealth",
        sender_email: "info@repeathealth.com", // Replace with dynamic sender email
        title: `Hallo ${first_name}, Welkom bij RepeatConnect!`,
        receiver_email: email, // Replace with dynamic receiver email
        gebruikersnaam: email, // Replace with dynamic username
        name: name || `${first_name} ${last_name}`,
        wachtwoord: password, // Replace with dynamic password
        inloglink: "https://repeatconnect.com", // Replace with the login URL
      };

      deleteAfspraak(index);
      const emailHtml = emailHTML(emailData);

      sendEmail('template_qdoh9mv',{ message_html: emailHtml,title:`Hallo ${first_name}, Welkom bij RepeatConnect!`,receiver_email: emailData?.receiver_email}) // Replace with dynamic receiver email
    
    } catch (error) {
      console.error("Error:", error);
      alert("Er is een fout opgetreden tijdens het proces.");
    }
  };

  // Helper functions
  const validateUserInput = (username, password) => {
    const usernameRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$|^[a-zA-Z0-9_]+$/;
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{3,}$/;

    if (!username?.trim() || !usernameRegex.test(username)) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Ongeldige gebruikersnaam of e-mailadres",
        showConfirmButton: false,
        timer: 2500,
      });
      return false;
    }

    if (!password?.trim()) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title:
          "Wachtwoord moet minimaal 3 karakters lang zijn, minstens één hoofdletter, één nummer en één speciaal karakter bevatten",
        showConfirmButton: false,
        timer: 2500,
      });
      return false;
    }

    return true;
  };

  const createUser = async (id, username, password) => {
    const response = await AXIOS_POST("auth/signup", {
      id,
      username,
      password,
      role: 2,
      email: null,
      platform: "calendly",
    });

    if (response.data.affectedRows === 1) {
      await Swal.fire({
        position: "top-start",
        icon: "success",
        title: `Bedankt voor de registratie.\nKlant ${username} is aangemaakt`,
        showConfirmButton: false,
        timer: 2500,
      });
    }
  };

  const updateUserDetails = async (id, details) => {
    const response = await AXIOS_UPDATE("users", id, details);
    if (response.data.data.affectedRows === 1) {
      await Swal.fire({
        position: "center",
        icon: "success",
        title: "Bedankt voor het bij vullen van de gegevens.",
        showConfirmButton: false,
        timer: 2500,
      });
    }
  };


  return (
    <Dialog open={open} onClose={setOpen} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-full overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-0 text-center sm:items-center sm:p-4">
          <DialogPanel
            transition
            className="relative h-[92dvh] w-full max-w-6xl transform overflow-hidden rounded-t-2xl border border-wa-border bg-wa-panel2 pb-4 pt-0 text-left shadow-xl transition-all sm:h-[90dvh] sm:rounded-2xl data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            {loading && <Spinner />}
            <div className="h-full min-h-0 w-full overflow-y-auto p-3 sm:p-5">
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
                {data?.length > 0 ? (
                  data.map((item, key) => (
                    <article
                      className="flex h-full flex-col rounded-xl border border-wa-border bg-wa-panel p-3"
                      key={item?.uri || `${item?.start_time || "event"}-${key}`}
                    >
                      <CalendarDateRangeIcon className="h-8 w-8 text-wa-muted" />
                      <p className="mt-2 flex items-center gap-2 text-base font-semibold text-wa-text">
                        <span className="h-2 w-2 rounded-full bg-green-500" />
                        <span className="break-words">{item?.name}</span>
                      </p>
                      <p className="text-sm text-wa-muted">{moment(item.start_time).format("LL")}</p>
                      <p className="text-sm italic text-wa-text">
                        {moment(item.start_time).format("HH:mm")} - {moment(item.end_time).format("HH:mm")}
                      </p>

                      <div className="mt-3 space-y-2">
                        {(item?.invitees || []).map((invitee, index) => (
                          <div
                            title={invitee?.questions_and_answers?.[0]?.answer}
                            className="rounded-lg border border-wa-border bg-wa-panel2 p-2.5"
                            key={`${invitee?.email || "invitee"}-${index}`}
                          >
                            <p className="text-xs italic text-wa-muted">Klant</p>
                            <p className="break-words text-sm font-medium text-wa-text">{invitee?.name}</p>
                            <p className="break-all text-xs text-wa-muted">{invitee?.email}</p>
                          </div>
                        ))}
                      </div>

                      <div className="mt-2 space-y-2">
                        {(item?.creators || []).map((invitee, index) => (
                          <div
                            className="rounded-lg border border-green-500/60 bg-wa-panel2 p-2.5"
                            key={`${invitee?.user_email || "creator"}-${index}`}
                          >
                            <p className="text-xs italic text-green-500">Specialist</p>
                            <p className="break-words text-sm font-medium text-wa-text">{invitee?.user_name}</p>
                            <p className="break-all text-xs text-wa-muted">{invitee?.user_email}</p>
                          </div>
                        ))}
                      </div>

                      <div className="mt-3">
                        {!allUsers.find((user) => user == item?.invitees?.[0]?.email) && item?.invitees?.[0] ? (
                          <button
                            type="button"
                            onClick={() => handleSignUp(item.invitees[0], item, key)}
                            className="w-full rounded-lg bg-wa-accent px-3 py-2 text-center text-sm font-semibold text-wa-onaccent shadow-sm transition hover:brightness-110"
                          >
                            Inschrijven
                          </button>
                        ) : (
                          <div className="w-full rounded-lg border border-wa-border bg-wa-panel2 px-3 py-2 text-center text-xs text-wa-muted">
                            Reeds geregistreerd
                          </div>
                        )}
                      </div>
                    </article>
                  ))
                ) : (
                  <div className="rounded-xl border border-dashed border-wa-border bg-wa-panel px-4 py-10 text-center sm:col-span-2 xl:col-span-3">
                    <p className="text-sm text-wa-muted">
                      Afspraken gemaakt in Calendly voor de komende 24 uur of later.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default Calendly;
